// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BottomBanner__container___2EuBi{padding:160px 60px;text-align:center}@media (max-width:719px){.BottomBanner__container___2EuBi{padding:80px 30px}}.BottomBanner__text___tAP8A h2{font-weight:200;font-size:48px;line-height:55px}.BottomBanner__text___tAP8A p{color:inherit;font-weight:500;font-size:20px;line-height:32px;margin-top:16px}.BottomBanner__cta___5YT_e{margin-top:40px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "BottomBanner__container___2EuBi",
	"text": "BottomBanner__text___tAP8A",
	"cta": "BottomBanner__cta___5YT_e"
};
module.exports = ___CSS_LOADER_EXPORT___;
